import React from "react";
import { Link } from "react-router-dom";
import { BadgePercent } from "lucide-react";

export default function PublicFooter() {
  return (
    <footer className="border-t border-gray-200 bg-white" data-testid="public-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid md:grid-cols-4 gap-8">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <div className="w-8 h-8 rounded-lg bg-emerald-700 text-white flex items-center justify-center">
              <BadgePercent className="w-4 h-4" />
            </div>
            <span className="font-display font-bold text-base">LoyaltyCircle AI</span>
          </div>
          <p className="text-sm text-gray-600 leading-relaxed">
            AI finds the best deals for your life, and you earn cashback when you shop.
          </p>
        </div>
        <div>
          <h4 className="font-display font-semibold text-sm mb-3">Product</h4>
          <ul className="space-y-2 text-sm text-gray-600">
            <li><Link to="/how-it-works" className="hover:text-emerald-700">How it works</Link></li>
            <li><Link to="/categories" className="hover:text-emerald-700">Categories</Link></li>
            <li><Link to="/app/ria" className="hover:text-emerald-700">AI Assistant</Link></li>
            <li><Link to="/app/wallet" className="hover:text-emerald-700">Cashback Wallet</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold text-sm mb-3">Company</h4>
          <ul className="space-y-2 text-sm text-gray-600">
            <li><Link to="/for-merchants" className="hover:text-emerald-700">For merchants</Link></li>
            <li><Link to="/faq" className="hover:text-emerald-700">FAQ</Link></li>
            <li><Link to="/compliance" className="hover:text-emerald-700">Compliance & Terms</Link></li>
            <li><Link to="/privacy" className="hover:text-emerald-700">Privacy</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold text-sm mb-3">Get the deals</h4>
          <p className="text-sm text-gray-600 mb-3">Join free. Earn cashback on verified purchases.</p>
          <Link
            to="/signup"
            data-testid="footer-signup"
            className="inline-flex items-center justify-center rounded-full bg-emerald-700 hover:bg-emerald-800 text-white px-5 py-2 text-sm font-medium transition-colors"
          >
            Create account
          </Link>
        </div>
      </div>
      <div className="border-t border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col md:flex-row justify-between text-xs text-gray-500 gap-2">
          <span>© {new Date().getFullYear()} LoyaltyCircle AI. All rights reserved.</span>
          <span>Cashback subject to merchant confirmation. Not financial advice.</span>
        </div>
      </div>
    </footer>
  );
}
